import React from "react";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

const SortIndicator = ({ active, order, columnKey, currentSortConfig }) => {
  // Handle the new props format (active, order)
  if (active !== undefined && order !== undefined) {
    if (active) {
      return order === "desc" ? (
        <ArrowDown className="h-4 w-4 ml-1 inline" />
      ) : (
        <ArrowUp className="h-4 w-4 ml-1 inline" />
      );
    }
    return <ArrowUpDown className="h-4 w-4 ml-1 inline opacity-30" />;
  }

  // Handle the old props format (columnKey, currentSortConfig) for backward compatibility
  if (columnKey !== undefined && currentSortConfig !== undefined) {
    if (currentSortConfig.key === columnKey) {
      return currentSortConfig.direction === "desc" ? (
        <ArrowDown className="h-4 w-4 ml-1 inline" />
      ) : (
        <ArrowUp className="h-4 w-4 ml-1 inline" />
      );
    }
    return <ArrowUpDown className="h-4 w-4 ml-1 inline opacity-30" />;
  }

  // Default fallback
  return <ArrowUpDown className="h-4 w-4 ml-1 inline opacity-30" />;
};

export default SortIndicator;
